module.exports = __webpack_public_path__ + "media/v2/components/shared/InstagramCarousel/mockPicts/Rectangle-66c25e663beb0a17ca558f401e3629bb.png";